"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  d: "M10.4 1.09a5.6 5.6 0 014.5 4.51h-4.5V1.1zm0-1.01A6.6 6.6 0 0116 6.6H9.4V0c.34 0 .67.03 1 .08zm2.74 8.19c.06.35.1.72.1 1.1v.03a6.62 6.62 0 11-6.62-6.63c.27 0 .5.22.5.5v5.61h5.61c.28 0 .5.22.5.49a6.67 6.67 0 00-.09-1.1zM6.12 9.38v-5.6a5.62 5.62 0 106.1 6.1h-5.6a.5.5 0 01-.5-.5z"
}));

exports["default"] = _default;